export const USER_STORE_NAME = 'user';
export const CADASTRE_STORE_NAME = 'cadastre';
export const TABLE_STORE_NAME = 'table';
export const MODAL_STORE_NAME = 'modal';
export const HEADER_STORE_NAME = 'header';
